import { isDefined } from "@clipboard-health/util-ts";
import { type BreakPolicy } from "@src/appV2/Shifts/Shift/types";
import { differenceInMinutes } from "date-fns";

interface IsMandatoryBreakRequiredParams {
  policy: BreakPolicy | undefined;
  clockInTime?: Date;
  clockOutTime?: Date;
}

export function isMandatoryBreakRequired(params: IsMandatoryBreakRequiredParams): boolean {
  const { policy, clockInTime, clockOutTime } = params;

  if (!isDefined(policy)) {
    return false;
  }

  if (!isDefined(clockInTime) || !isDefined(clockOutTime)) {
    return false;
  }

  const workedMinutes = differenceInMinutes(clockOutTime, clockInTime);
  return workedMinutes > policy.minShiftDurationInMinutes;
}
